module.exports = __webpack_public_path__ + "static/media/Ellipse 1091.408f84c1.png";